<error-dialog [error]="errorText" [show]="errorDialog"/>
<breadcrumb endText="Problem Templates" [navigations]="breadcrumbNavs" />
<hr />
<!-- TODO add descending and tag filter -->
<div class="m-5">
  <p class="font-medium text-2xl mb-1">
    View Templates
  </p>
  <hr class="mb-3" />
  <div class="flex items-center mb-7">
    <search-bar [(searchText)]="searchText" (debounceSearch)="debounceSearch()" />
  </div>
  <div class="mb-5">
    <div class="text-[14px] font-semibold ml-3 mb-1">
      All
    </div>
    <hr class="mb-2" />
    <div class="flex items-center">
      <div class="text-[12px] text-[#A2ADB9] ml-3">
        Showing {{(pageNumber * limit) + 1}} - {{totalCount < ((pageNumber+1) * limit) ? totalCount : ((pageNumber+1) * limit)}} of {{totalCount}}
      </div>
      <dropdown-menu
        role="menu"
        [text]="limit.toString()"
        [icon]="faChevronDown"
        [menuItems]="limitMenu"
        [(limit)]="limit"
        (getPage)="getPage()"
        aria-label="Problem Template Menu"
        containerClass="border border-[#5D6974] bg-[#F6F7F8] text-[10px] p-[6px] rounded-[8px] h-[28px] flex justify-center ml-[50px] items-center w-[40px]"
        clickedContainerClass="border border-[#5D6974] bg-[#F6F7F8] text-[10px] p-[6px] rounded-[8px] h-[28px] flex justify-center ml-[50px] items-center w-[40px]"
        menuClass="absolute border rounded-[8px] border-[#8B96A2] bg-[#F6F7F8] shadow-sm z-10 flex flex-col overflow-hidden mt-1 ml-[50px] text-[12px] w-[40px]"
        />
      </div>
    </div>
    <div class="mt-1">
      <div class="grid grid-cols-6 text-sm font-bold px-2">
        <button (click)="toggleNameDescending()" class="col-span-2 w-fit" aria-label="Order By Name">
          Name
          @if (isDescending) {
            <fa-icon [icon]="faCaretUp" class="ml-1"/>
          }
          @if (!isDescending) {
            <fa-icon [icon]="faCaretDown" class="ml-1"/>
          }
        </button>
        <button (click)="toggleTypeDescending()" class="w-fit" aria-label="Order By Type">
          Type
          @if (isTypeDescending) {
            <fa-icon [icon]="faCaretUp" class="ml-1"/>
          }
          @if (!isTypeDescending) {
            <fa-icon [icon]="faCaretDown" class="ml-1"/>
          }
        </button>
        <button (click)="toggleDateDescending()" class="w-fit" aria-label="Order By Date Updated">
          Date Updated
          @if (isDateDescending) {
            <fa-icon [icon]="faCaretUp" class="ml-1"/>
          }
          @if (!isDateDescending) {
            <fa-icon [icon]="faCaretDown" class="ml-1"/>
          }
        </button>
        <div>
          Tags
        </div>
        <div>
          Action
        </div>
      </div>
      <hr class="mt-1 mb-3" />
      @if (!isLoading) {
        <div>
          @for (problem of problemTemplates; track problem) {
            <div class="px-2 mb-3 text-xs">
              <div class="grid grid-cols-6">
                <div class="col-span-2">
                  {{problem.name}}
                </div>
                <div>
                  {{problem.answer_type}}
                </div>
                <div>
                  {{problem.last_updated | date: "MM/dd/y"}}
                </div>
                <div class="text-[10px] text-center">
                  @if (problem.tag_list.length === 0) {
                    <div class="rounded-full border border-[#CBD1D7] bg-[#F6F7F8] px-1.5 min-w-[25px] w-fit">
                      No tags
                    </div>
                  }
                  <div class="flex">
                    @for (tag of problem.tag_list; track tag) {
                      <div class="rounded-full border border-[#CBD1D7] bg-[#F6F7F8] px-1.5 min-w-[25px] mr-1">
                        {{tag.name}}
                      </div>
                    }
                  </div>
                </div>
                <dropdown-menu role="menu" [menu_id]="problem.problemtemplate_id" [menuItems]="problem.menuItems" aria-label="Problem Template Menu" />
              </div>
              <hr class="mt-3"/>
            </div>
          }
        </div>
      }
      @if (isLoading) {
        <div class="mr-1">
          <div class="w-full p-2 animate-pulse bg-gray-100 rounded-lg h-[50px] mb-3"></div>
          <div class="w-full p-2 animate-pulse bg-gray-100 rounded-lg h-[50px] mb-3"></div>
          <div class="w-full p-2 animate-pulse bg-gray-100 rounded-lg h-[50px] mb-3"></div>
        </div>
      }
    </div>
    <div class="flex justify-center items-center pb-3">
      <button (click)="decrementPage()" class="p-1 text-[#74808B] text-[9px] hover:bg-[#e3e7ea] rounded-[8px] w-[28px] h-[25px] flex justify-center items-center" aria-label="Decrement Page">
        <fa-icon [icon]="faArrowLeft" />
      </button>
      <div class="text-[12px]">
        @for (page of pageNumberList| slice:pageScrollOver:pageScrollOver + 3; track page) {
          <button (click)="selectPage(page)">
            @if (page === pageNumber + 1) {
              <div class="bg-[#B9C2CA] rounded-[8px] w-[28px] h-[25px] flex justify-center items-center ml-1">
                {{page}}
              </div>
            }
            @if (page !== pageNumber + 1) {
              <div class="hover:bg-[#e3e7ea] rounded-[8px] w-[28px] h-[25px] flex justify-center items-center ml-1">
                {{page}}
              </div>
            }
          </button>
        }
      </div>
      <button (click)="incrementPage()" class="p-1 text-[#74808B] text-[9px] ml-1 hover:bg-[#e3e7ea] rounded-[8px] w-[28px] h-[25px] flex justify-center items-center" aria-label="Increment Page">
        <fa-icon [icon]="faArrowRight" />
      </button>
    </div>
  </div>
